import { useEffect, useState } from "react";

const LOADING_SAYINGS = [
  "Gathering team highlights...",
  "Loading listing photos...",
  "Crunching the numbers...",
  "Preparing your Spotlight...",
  "Almost there...",
  "Putting it all together...",
];

interface SpotlightLoadingProps {
  companyLogoUrl?: string | null;
}

export function SpotlightLoading({ companyLogoUrl }: SpotlightLoadingProps) {
  const [currentSayingIndex, setCurrentSayingIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSayingIndex((prev) => (prev + 1) % LOADING_SAYINGS.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)",
      }}
    >
      <div className="flex flex-col items-center justify-center space-y-8">
        {companyLogoUrl && (
          <img
            src={companyLogoUrl}
            alt="Company Logo"
            className="h-16 w-auto max-w-[200px] object-contain animate-pulse brightness-0 invert"
          />
        )}

        {/* Horizontal line animation */}
        <div className="w-48 h-0.5 bg-white/10 rounded-full overflow-hidden">
          <div className="h-full w-1/3 bg-white/60 rounded-full animate-[gradient-shift_2s_ease-in-out_infinite]" />
        </div>

        <div className="h-8 flex items-center justify-center">
          <p
            key={currentSayingIndex}
            className="text-lg text-white/50 text-center animate-fade-in"
          >
            {LOADING_SAYINGS[currentSayingIndex]}
          </p>
        </div>
      </div>
    </div>
  );
}
